export const STEP_TITLE = "Step 2: Confirm When You’d Like To Pay";
export const STEP_SUBTITLE =
  "Enjoy the same cancellation policy and premium benefits for either payment option.";
export const PAY_NOW_LABEL = (paymentCardType: string) =>
  `Pay today with your ${paymentCardType} card and earn 10X miles `;
export const PAY_LATER_LABEL = (paymentCardType: string) =>
  `Pay at hotel with your ${paymentCardType} card and earn 2X miles`;
export const EDIT = "Edit";

export const PAY_LATER_NOTES =
  "Please note that miles, travel credits and offers can’t be applied to the booking when paying at the hotel.";
